import { Job2Dto } from './Job2Dto';

export class Job2DtoExtended extends Job2Dto {
  public displayName: string;

  constructor(o: any = null) {
    super(o);
  }
}
